import { createExpenseRules } from "./expenseRules"

export { createExpenseRules as ExpenseRules }
